import React from "react";
import "../componentsStyle.scss";
import { shkodraMap } from "../../assets/photos";
import { TimeSvg } from "../../assets/svg";

export const ContactMap = () => {
  return (
    <section className="info-hero">
      {/* Background Image */}
      <img src={shkodraMap} alt="Travel" className="info-hero-image" />

      {/* Dark Overlay */}
      <div className="info-hero-overlay" />

      {/* Content Container */}
      <div className="info-hero-content">
        <div className="label">We're Here to Help</div>

        <div className="des">
          Whether you have questions about tours, booking, or special requests,
          our team is ready to assist you.
        </div>

        <div className="desLogo">
          <TimeSvg
            width={32}
            height={32}
            fill={"#FFFFFF"}
            style={{ marginRight: "8px" }}
          />

          <span>Reply within 24 hours</span>
        </div>
      </div>
    </section>
  );
};
